module.exports = __webpack_public_path__ + "static/media/dark-icon-messages.3aa4fd3e.png";